import React from 'react';
import { useIsSkySlopeMobileApp } from '@/common/utils';
import { EditEmailModal } from '@/components/senderBuild/EditEmailModal';
import { useDispatch, useShallowSelector } from '@/lib/reduxHooks';
import validateBlocksAndSendEnvelope from '@/lib/validateBlocksAndSendEnvelope';
import { postMessageToMobileApp } from '@/utils/post-message';
import * as actions from '../../store/senderBuild/actions';

export function MobileAppEditEmailModal() {
  const dispatch = useDispatch();
  const isMobileApp = useIsSkySlopeMobileApp();

  const state = useShallowSelector((state) => ({
    selectedBlocks: state.senderBuild.selectedBlocks,
    done: state.senderBuild.done,
    saving: state.senderBuild.saving,
    blocks: state.senderBuild.blocks,
    groups: state.senderBuild.groups,
    mobileSigningOrderOpen: state.senderBuild.mobileSigningOrderOpen,
    // emailConfig: state.senderBuild.emailConfig,
    readyToSendModalOpen: state.senderBuild.readyToSendModalOpen,
    // successShow: state.pageFrame.successShow,
    // errorShow: state.pageFrame.errorShow,
    zoom: state.senderBuild.zoom,
    // signers: state.senderBuild.signers,
  }));

  function toggleModal(skipCloseModal = false) {
    if (!skipCloseModal) dispatch(actions.toggleReadyToSendModal());
    const sb = state.selectedBlocks;
    if (sb.blockIndices.length > 0) {
      dispatch(actions.selectBlocks(sb.documentId!, sb.pageIndex!, []));
    }
  }

  // TODO: It's weird that this sets the same function that's set inside the effect
  // This is also set inside of EditEmailModal.tsx.
  window.mobileApp.nextButtonTap = () => {
    if (!state.mobileSigningOrderOpen && !state.saving) {
      toggleModal();
    }
  };
  React.useEffect(() => {
    window.mobileApp.nextButtonTap = () => {};
    window.mobileApp.backButtonTap = () => {};
  }, []);

  React.useEffect(() => {
    if (isMobileApp && !state.saving && !state.readyToSendModalOpen && !state.mobileSigningOrderOpen && !state.done) {
      postPrepareForSignMessage();
    }

    function postPrepareForSignMessage() {
      postMessageToMobileApp({
        header_text: 'Prepare for Signature',
        back_button_type: '<',
        should_back_button_exit: true,
        button_text: 'Next',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- This code was written prior to enforcing lint rules
  }, [state.saving, state.readyToSendModalOpen, state.mobileSigningOrderOpen]);

  if (!isMobileApp || !state.readyToSendModalOpen) return null;
  return (
    <EditEmailModal
      fullScreen
      handleBackButtonTap={toggleModal}
      sendEnvelopeForMobileApp={async (emailConfig: { subject: string; body: string }) => {
        toggleModal(true);

        // this doesn't actually send the envelope, it just validates the blocks
        const updatedBlocksAndGroups = await validateBlocksAndSendEnvelope(
          state.blocks,
          state.groups,
          true, // sendEnvelope
          state.zoom
        );

        dispatch(
          actions.validateBlocksBeforeSending(
            updatedBlocksAndGroups?.updatedBlocks ?? [],
            updatedBlocksAndGroups?.updatedGroups ?? [],
            emailConfig,
            true // sendEnvelope
          )
        );
      }}
    />
  );
}
